import ReadOnlyPad from "./ReadOnlyPad";

export default ReadOnlyPad;
